// extracted by mini-css-extract-plugin
export var baseButton = "_pf-0";
export var controlsArrowKeys = "_pf-1";
export var controlsResetButton = "_pf-2";
export var lightGameButton = "_pf-4 _pf-0";
export var playAgainButton = "_pf-5 _pf-0";
export var startGameButton = "_pf-3 _pf-0";